import styled from 'styled-components/macro';

export const Icon = styled.span`
  font-size: 150px;
`;
